export const DEFAULT_MAP_CONFIG = {
    center: [56.96583393670644, 23.78488053560194],
    zoom: 11,
};
